<template>
  <div :id="'comment-' + id" class="relative my-5">
    <div>
      <div class="relative shadow shadow-zt-shadow bg-zt-normal border -m-[1px] rounded-md"
           :class="[showNewBetShadow ? 'border-zt-more' : 'border-zt-normal', isBetOptionsModalOpen ? 'z-backdrop' : '']">

        <div ref="content" class="px-5 py-3 break-words font-light xl:px-5">
          <div :id="'bonus-content-' + data.comment_id"
               class="bonus-content searched-in text-left text-sm">
            <img :src="'/wp-content/themes/zawodtyper/assets/images/bet_ad_suppi.png'" width="357" height="121"
                 alt="Wesprzyj Typerów" class="block mx-auto !mt-1">
            Na profilach niektórych najpopularniejszych Typerów pojawił się przycisk <span class="text-zt-red font-semibold">WESPRZYJ</span>, który pozwala Ci docenić ulubionych Typerów.
            <span class="text-zt-more text-[11px] inline-block mt-1">Żadnych prowizji - do wspieranego trafia 100% kwoty!</span>
          </div>
        </div>

        <hr v-if="!isModal && (likingEnabled || commentingEnabled)"
            class="border-b border-zt-light/35 mx-auto w-full !border-t-0 xl:mt-1" />

        <div v-if="!isModal && (likingEnabled || commentingEnabled)"
             class="h-[42px] flex justify-between items-center pl-1.5 pr-3 xl:pl-2.5 xl:pr-4">
          <div class="group flex highlight-none grow">
            <div v-if="likingEnabled" class="flex items-center gap-0.5 mr-1 text-sm duration-500 transition-colors cursor-pointer zt-hover"
                 :class="isLikedByMe ? 'text-[#419AD4]' : 'text-zt-more'" @click="toggleLike">
              <svg class="w-7 h-7 overflow-hidden rounded-full transition-colors duration-[1s] shrink-0"
                   :class="[{ 'animate-[like-animation_1s]': animate }, isLikedByMe ? 'stroke-transparent fill-[#419AD4]' : 'stroke-zt-more fill-transparent']"
                   viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.02052 3.29201C7.97899 3.31156 7.953 3.35321 7.95412 3.39843C7.97027 4.05479 7.97835 4.43525 7.97835 4.53979V4.83551L7.92797 4.93901C7.8714 5.05524 7.84218 5.10345 7.42778 5.76467C7.26549 6.02362 7.051 6.37847 6.95113 6.55326C6.8321 6.76157 6.7698 6.99652 6.77024 7.23539L6.77615 10.4265C6.77687 10.8176 7.09988 11.1342 7.49809 11.1342H11.0513L11.1808 11.0718C11.4717 10.9316 11.6853 10.6054 11.6868 10.2988C11.6874 10.1806 11.6836 10.1653 11.6225 10.0417C11.5868 9.96934 11.5594 9.90908 11.5617 9.90775C11.564 9.90642 11.631 9.87712 11.7107 9.84266C12.053 9.69455 12.2544 9.45916 12.269 9.19021C12.2767 9.04821 12.2428 8.95009 12.1285 8.78295C12.0824 8.71557 12.0447 8.65649 12.0447 8.65164C12.0447 8.6468 12.0558 8.64284 12.0695 8.64284C12.0831 8.64284 12.1498 8.61458 12.2177 8.58004C12.5277 8.4223 12.7052 8.12287 12.6549 7.84249C12.6214 7.65568 12.5212 7.50716 12.2986 7.31427L12.2256 7.25107L12.3095 7.16301C12.4176 7.04942 12.4832 6.95595 12.5262 6.85412C12.5546 6.78718 12.5609 6.74432 12.5612 6.6166C12.5617 6.37306 12.5044 6.20983 12.3687 6.06876C12.2778 5.97426 12.1765 5.91277 12.0332 5.86522L11.9155 5.82615C10.2991 5.81738 9.49093 5.81105 9.49096 5.80717C9.49102 5.80134 9.50466 5.6868 9.52127 5.55262C9.55932 5.24537 9.56347 4.6846 9.52919 4.48065C9.43159 3.89988 9.1171 3.44498 8.70331 3.28599C8.5997 3.24619 8.56565 3.2406 8.40398 3.23694C8.30366 3.23467 8.19168 3.2389 8.15517 3.24635C8.11864 3.25379 8.05805 3.27434 8.02052 3.29201ZM4.65918 6.73157H6.03585C6.1572 6.73157 6.25557 6.82819 6.25557 6.94737V11.2209C6.25557 11.3401 6.1572 11.4367 6.03585 11.4367H4.65918C4.53783 11.4367 4.43945 11.3401 4.43945 11.2209V6.94737C4.43945 6.82819 4.53783 6.73157 4.65918 6.73157Z" stroke-width="0.5" />
              </svg>
              <span class="text-xs xl:text-sm">Lubię to!</span>
              <span @animationend="wsLikeAdded = false" class="text-xs mt-[1px] xl:ml-[3px] xl:mr-1">({{ likeCount }})</span>
            </div>
          </div>
          <div v-if="commentingEnabled" @click="toggleAnswer"
               class="flex flex-nowrap justify-center items-center cursor-pointer highlight-none zt-hover">
            <button data-bs-toggle="collapse" :data-bs-target="'#Comment-input-' + data.comment_id"
                    class="text-zt-more text-xs xl:text-sm">Komentarze ({{ commentWithAnswersCount }})</button>
          </div>
        </div>

        <div :id="'Comment-input-' + data.comment_id" class="collapse">
          <div class="w-full h-0.5 bg-zt-light"></div>
          <div v-if="isLoggedIn() && !isUserBlocking" class="flex relative py-2 justify-center items-center gap-x-2 px-1.5 xl:px-2.5">
            <img class="rounded-full w-[30px] h-[30px] min-w-[30px]" height="30" width="30" :src="WP.user.avatar"
                 alt="" @error="handleUserAvatarError($event)"/>
            <textarea placeholder="Napisz komentarz..." ref="textarea" rows="1" @focus="resize()" @keyup="resize()"
                      v-model="answerContent"
                      class="font-light py-2 pl-3 !text-text textarea-comments self-stretch overflow-hidden resize-none
                             focus:outline-none pr-10"></textarea>
            <div class="absolute top-0 h-full flex items-center right-[18px] xl:right-2">
              <button class="zt-hover xl:h-[calc(100%-20px)] xl:px-4" aria-label="Dodaj komentarz" @click="addComment">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7267 7.55476L2.72665 2.05476C2.64044 2.01164 2.5436 1.99437 2.44779 2.00501C2.35198 2.01566 2.2613 2.05377 2.18665 2.11476C2.11536 2.17451 2.06215 2.25295 2.03301 2.34128C2.00386 2.42961 1.99993 2.52432 2.02165 2.61476L3.50165 7.99976L2.00165 13.3698C1.98126 13.4453 1.97888 13.5245 1.9947 13.6012C2.01052 13.6778 2.0441 13.7496 2.09273 13.8109C2.14136 13.8722 2.2037 13.9212 2.27472 13.954C2.34574 13.9868 2.42347 14.0025 2.50165 13.9998C2.57992 13.9993 2.65699 13.9805 2.72665 13.9448L13.7267 8.44476C13.8086 8.4028 13.8773 8.33905 13.9253 8.26054C13.9733 8.18202 13.9987 8.09178 13.9987 7.99976C13.9987 7.90774 13.9733 7.8175 13.9253 7.73898C13.8773 7.66047 13.8086 7.59672 13.7267 7.55476ZM3.27665 12.5548L4.38165 8.49976H9.00165V7.49976H4.38165L3.27665 3.44476L12.3817 7.99976L3.27665 12.5548Z" fill="#93A3BA"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="isUserBlocking" class="flex justify-center items-center p-2 mt-0.5">
            <span class="text-zt-red text-[12px] zt-hover cursor-pointer truncate" @click="openLoginModal">
              Zostałeś zablokowany przez tego Typera, nie mozesz skomentować jego typu
            </span>
          </div>
          <div v-else class="flex justify-center items-center p-2 text-sm">
            <div class="flex justify-center items-center gap-1 zt-hover cursor-pointer" @click="openLoginModal">
              <span class="text-zt-red font-medium">Zaloguj się,</span>
              <span>aby dodać komentarz</span>
            </div>
          </div>
        </div>
      </div>

      <TransitionGroup name="fade">
        <comment v-for="comment in commentsToShow"
                 :key="comment.comment_id"
                 :data="comment"
                 :isBlocked="false"
                 :isBlocking="false"
                 :isBetComment="true"
                 :blockedUserIds="blockedUserIds"
                 @blockUser="commentAuthorId => $emit('blockUser', commentAuthorId)"
                 @unblockUser="commentAuthorId => $emit('unblockUser', commentAuthorId)" />
      </TransitionGroup>

      <div v-if="!showAllComments && comments.length > 1" class="flex justify-center items-center">
        <button class="bg-zt-main shadow-around px-6 py-2 text-[12px] underline rounded-md mt-2"
                @click="showAllComments = true">
          Pokaż {{ comments.length - 1 }} {{ inflectNumber(comments.length - 1, ['komentarz', 'komentarze', 'komentarzy']) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '../../Comment.vue';
import { defineAsyncComponent } from 'vue';
import utils_mixin from '../../../mixins/utils_mixin';
import { useUserStore } from '../../../stores/UserStore';
import { Notice } from '../../../../assets/js/Notice';
import TinyMCE from '../../TinyMCE.vue';

export default {
  name: 'BetAdSuppi',
  emits: ['blockUser', 'unblockUser'],
  props: {
    data: Object,
    isBlocked: Boolean,
    isBlocking: Boolean,
    isWarned: Boolean,
    blockedUserIds: Array,
    blockingUserIds: Array,
    warnedUserIds: Array,
    isFeaturedBet: Boolean,
    isModal: Boolean,
    betEdited: Number,
    likingEnabled: {
      type: Boolean,
      default: true,
    },
    commentingEnabled: {
      type: Boolean,
      default: true,
    },
  },
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    TinyMCE,
    Comment,
    BetOptionsModal: defineAsyncComponent(() => import('../../modals/BetOptionsModal.vue')),
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  data() {
    return {
      isBetOptionsModalOpen: false,
      comments: [],
      animate: false,
      followChanged: false,
      showNewBetShadow: false,
      answerContent: '',
      lastCommentTimestamp: 0,
      isAnswerOpen: false,
      wsLikeAdded: false,
      showAllComments: false,
      userCanEdit: false,
      toEdit: false,
      isUserWithAdminPanel: this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor',
      likeCount: this.data?.like_count || 0,
    };
  },
  computed: {
    id() {
      return Number(this.data.comment_id);
    },
    postId() {
      return Number(this.data.post_id);
    },
    authorId() {
      return Number(this.data.author_id);
    },
    isFollowed() {
      return this.userStore.isUserFollowed(this.authorId);
    },
    isUserBlocked() {
      return this.isBlocked;
    },
    isUserBlocking() {
      return this.isBlocking;
    },
    likes() {
      if (this.isModal) {
        return null;
      }
      return this.data.likes;
    },
    isLikedByMe() {
      if (this.isModal || this.likeCount === 0) {
        return false;
      }
      return this.userStore.isCommentLiked(this.id);
    },
    commentWithAnswersCount() {
      let count = 0;
      if (this.comments.length > 0) {
        this.comments.forEach(child => {
          if ('answers' in child && child.answers.length > 0) {
            count += child.answers.length;
          }
          count++;
        });
      }
      return count;
    },
    commentsToShow() {
      let commentsSorted = this.comments.slice().sort((a, b) => {
        if (a.pinned_to_all !== b.pinned_to_all) {
          return b.pinned_to_all - a.pinned_to_all;
        }

        return new Date(b.date) - new Date(a.date);
      });

      if (this.showAllComments) {
        return commentsSorted;
      } else {
        return commentsSorted.slice(0, 1);
      }
    },
  },
  mounted() {
    this.comments = this.data.answers ? this.data.answers : [];
    this.checkAndRedirectToComment();
    this.addAdditionalStyles();
    this.ifHasJustBeenAdded();
    this.showBetRedirectBg();
    setTimeout(this.refreshTooltips, 500);

    socket?.on('like-added', data => {
      if (data.postId === Number(this.WP.id)) {
        this.addLikeBySomeoneElse(data);
      }
    });
    socket?.on('like-removed', data => {
      if (data.postId === Number(this.WP.id)) {
        this.removeLikeBySomeoneElse(data);
      }
    });
  },
  methods: {
    toggleLike() {
      this.animate = true;
      if (this.isLikedByMe) {
        this.animate = false;
        return this.removeLike();
      } else {
        return this.addLike();
      }
    },
    addLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_add_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.addLikedCommentId(this.id);
              this.likeCount++;
              socket?.emit('like-added', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: response.data.data.comment_like.user_id,
              });
            }
          }
        });
    },
    removeLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_delete_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.removeLikedCommentId(this.id);
              this.likeCount--;
              socket?.emit('like-removed', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: this.WP.user.id,
                ip: this.userIP
              });
            }
          }
        });
    },
    addLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount++;
        this.wsLikeAdded = true;
      }
    },
    removeLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount--;
      }
    },
    ifHasJustBeenAdded() {
      if (this.data.showNewBetShadow) {
        this.observeBetShadow();
      }
    },
    checkAndRedirectToComment() {
      const redirectURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      const isRedirecting = redirectURL.includes('#comment-');
      const dashIndex = redirectURL.lastIndexOf('-');

      if (isRedirecting && dashIndex && redirectURL !== expectedURL) { // only for hidden bet comments
        const commentId = redirectURL.substring(dashIndex + 1);
        this.comments.forEach((comment) => {
          if (comment.comment_id === commentId && this.comments.length > 1) {
            this.showAllComments = true;
          } else if (comment.answers.length > 0) {
            comment.answers.forEach((comment2ndLvl) => {
              if (comment2ndLvl.comment_id === commentId) {
                this.showAllComments = true;
              }
            })
          }
        })
      }
    },
    showBetRedirectBg() {
      const currentURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      if (currentURL === expectedURL) {
        this.observeBetShadow();
      }
    },
    observeBetShadow() {
      this.showNewBetShadow = true;
      let threshold = this.$el.getBoundingClientRect().height > window.innerHeight - 100
        ? (window.innerHeight - 100) / this.$el.getBoundingClientRect().height
        : 1.0;
      const newBetObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => (this.showNewBetShadow = false), 3000);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: threshold,
          rootMargin: '0px 0px 0px 0px'
        }
      );
      setTimeout(() => newBetObserver.observe(this.$el), 400);
    },
    checkInputForEmojiCode() {
      this.answerContent = this.answerContent.replace("+++", "✅");
      this.answerContent = this.answerContent.replace("---", "✖");
    },
    resize() {
      const { textarea } = this.$refs;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      this.checkInputForEmojiCode();
    },
    toggleAnswer() {
      this.isAnswerOpen = !this.isAnswerOpen;

      if (this.isAnswerOpen) {
        setTimeout(() => {
          const { textarea } = this.$refs;
          if (textarea) {
            textarea.focus();
          }
        }, 200);
      }
    },
    addComment() {
      if (this.lastCommentTimestamp && this.DateTime.now().toSeconds() - this.lastCommentTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny komentarz'));
        return;
      }

      let commentContent = this.answerContent.replaceAll("✅", "<span style='font-size: 18px;'>✅</span>");
      commentContent = commentContent.replaceAll("✖", "<span style='font-size: 18px;'>✖</span>");

      if (commentContent.replace(/\s/g, "").length < 1) {
        this.addInternalNotification(new Notice().setContent('Dodaj treść komentarza'));
        return;
      }

      this.lastCommentTimestamp = this.DateTime.now().toSeconds();

      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_comment',
          post_id: this.postId,
          parent_id: this.id,
          content: commentContent.trim(),
          comment_type: 'comment',
          year: this.DateTime.fromSQL(this.WP.dailyBetsDate).year,
          month: this.DateTime.fromSQL(this.WP.dailyBetsDate).month,
        })
        .then(response => {
          if (response.data.success) {
            this.comments.unshift(response.data.data.comment);
            this.isAnswerOpen = false;
            this.answerContent = '';
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    edit() {
      this.toEdit = true;
    },
    deleteBet() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_delete_comment',
          id: this.id
        })
        .then(response => {
          if (response.data.success) {
            this.addInternalNotification(new Notice().setContent(response.data.data.message + '. Odśwież stronę'));
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    addAdditionalStyles() {
      let divElement = document.querySelector("#bonus-content-" + this.data.comment_id);

      if (divElement) {
        let imgElement = divElement.querySelector("img");

        if (imgElement) {
          imgElement.style.borderRadius = "5px";
          imgElement.style.marginTop = "15px";
          imgElement.style.marginBottom = "5px";
        }
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 3000);
              return;
            }
          }
        }
      }
    }
  },
};
</script>

<style scoped>
.searched-in .searched-element {
  background-color: #6FAD6E99;
}
.bonus-content img {
  border-radius: 5px;
  margin: 10px auto;
}

.bonus-content > ul,
.bonus-rules > ul {
  list-style-type: disc;
  padding-left: 20px;
}

.bonus-content > ol,
.bonus-rules > ol {
  list-style-type: decimal;
  padding-left: 15px;
}
</style>